import React from "react";
import ReactDOM from "react-dom";
import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import { AppProvider } from "providers";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "react-datetime/css/react-datetime.css";
import "react-datepicker/dist/react-datepicker.css";

const app = (
    <AppProvider>
        <App />
    </AppProvider>
);

const rootEl = document.getElementById("root");
ReactDOM.render(app, rootEl);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
